import { render, staticRenderFns } from "./VisitorLayout.vue?vue&type=template&id=0edfa66c&"
import script from "./VisitorLayout.vue?vue&type=script&lang=js&"
export * from "./VisitorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports